









































































import { Component } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import ajax from "../../../lib/ajax";
@Component
export default class ChannelDetail extends AbpBase {
  columns: any[] = [
    {
      type: "selection",
      width: 60,
      align: "center"
    },
    {
      title: "代码",
      key: "diyCode",
      align: "center"
    },
    {
      title: "所属渠道",
      key: "parentName",
      align: "center"
    },
    {
      title: "店铺名称",
      key: "displayName",
      align: "center"
    },
    {
      title: "状态名称",
      slot: "isActive",
      align: "center"
    },
    {
      title: "区域",
      key: "address",
      align: "center"
    },
    {
      title: "负责人",
      key: "principal",
      align: "center"
    },
    {
      title: "手机",
      key: "phoneNumber",
      align: "center"
    }
  ];
  data: any[] = [];
  channelInfo: any = {};
  table: any = {
    totalCount: 0,
    pageSize: 10,
    current: 1
  };

  created() {
    this.getChannelForView();
    this.getStoreList();
  }
  // 渠道基本资料
  getChannelForView() {
    ajax
      .get(
        `api/services/app/Channel/GetChannelForView?Id=${this.$route.params.id}`
      )
      .then(res => {
        this.channelInfo = res.data.result;
      });
  }
  // 获取店铺列表
  getStoreList() {
    ajax
      .get(
        `/api/services/app/Channel/GetStoreList?ParentId=${
          this.$route.params.id
        }&MaxResultCount=${this.table.pageSize}&SkipCount=${(this.table
          .current -
          1) *
          this.table.pageSize}`
      )
      .then(res => {
        this.data = res.data.result.items;
        this.table.totalCount = res.data.result.totalCount;
      });
  }
  changePage(e) {
    this.table.current = e;
    this.getStoreList();
  }
  changePageSize(e) {
    this.table.pageSize = e;
    this.table.current = 1;
    this.getStoreList();
  }
}
